export const checkRequestError = (data) => {
  if (data?.error?.status >= 400) throw new Error(data.error.message);
};
